import { Navigate } from 'react-router-dom'
import { useLocation } from 'react-router-dom'

const RedirectToAnalyticsReports = () => {
  // FIXME: this is a hack to redirect legacy reports to analytics reports, can delete in a month
  const location = useLocation()
  const newLocation = {
    ...location,
    pathname: location.pathname.replace(/^\/reports/, '/analytics/reports'),
  }

  return <Navigate to={newLocation} />
}
export default RedirectToAnalyticsReports
